export default "__VITE_ASSET__DNkl$0Cm__"